import { render, staticRenderFns } from "./PhotoAndPrFacilities.vue?vue&type=template&id=da56ba7a&scoped=true&"
import script from "./PhotoAndPrFacilities.vue?vue&type=script&lang=js&"
export * from "./PhotoAndPrFacilities.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAndPrFacilities.vue?vue&type=style&index=0&id=da56ba7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da56ba7a",
  null
  
)

export default component.exports